import { call, fork, select, takeLatest } from 'redux-saga/effects';

import { fetchProvinces } from '../api'

import { provincesListActions } from './actions';
import { getProvincesListsById } from './selectors';

export function* loadProvincesList({payload}) {

  const { id, sessionId } = payload;
  const provincesList = yield select(getProvincesListsById, id);
  if (!provincesList) {
    yield call(fetchProvinces, id, {sessionId});
  }
}

//=====================================
//  WATCHERS
//-------------------------------------

export function* watchLoadProvinces() {
  yield takeLatest(provincesListActions.LOAD_PROVINCES, loadProvincesList);
}

//=====================================
//  ROOT
//-------------------------------------

export const provincesListSagas = [
  fork(watchLoadProvinces),
];
